module.exports = __webpack_public_path__ + "img/Group-32709-1-1-1.1f3d5cb4.png";